'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _util = require('../../../util');

var _util2 = _interopRequireDefault(_util);

var _spin = require('../../../spin');

var _spin2 = _interopRequireDefault(_spin);

var _bill = require('../../../bill');

var _bill2 = _interopRequireDefault(_bill);

var _util3 = require('../util');

var _lodashCompat = require('lodash-compat');

var _icon = require('../../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _popover = require('./popover');

var _popover2 = _interopRequireDefault(_popover);

var _customFilter = require('./custom-filter');

var _customFilter2 = _interopRequireDefault(_customFilter);

var _slidingPanel = require('./sliding-panel');

var _slidingPanel2 = _interopRequireDefault(_slidingPanel);

var _AdvancedSearch = require('./AdvancedSearch');

var _AdvancedSearch2 = _interopRequireDefault(_AdvancedSearch);

var _KeyCode = require('../../../util/rc-util/KeyCode');

var _KeyCode2 = _interopRequireDefault(_KeyCode);

var _MultiSelect = require('./MultiSelect');

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

function createAddonAfter(addonAfter, search) {
  return _react2.default.cloneElement(standardAddonAfter, { children: addonAfter, onSearch: search });
}

/**
 * 搜索条件
 */

var Search = function (_M$BaseComponent) {
  _inherits(Search, _M$BaseComponent);

  function Search() {
    _classCallCheck(this, Search);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Search).apply(this, arguments));
  }

  _createClass(Search, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var baseCls = _props.className;
      var model = _props.model;
      var getInstanceRef = _props.getInstanceRef;
      var mode = model.mode;

      var conf = _objectWithoutProperties(model, ['mode']);

      var content = void 0;
      switch (mode) {
        case 'simple':
          content = _react2.default.createElement(Search.Simple, { ref: getInstanceRef, model: conf, className: baseCls + '--simple' });
          break;
        case 'complex':
          content = _react2.default.createElement(Search.Complex, { ref: getInstanceRef, model: conf, className: baseCls + '--complex' });
          break;
      }
      return _react2.default.createElement(
        'div',
        { className: this.classNames() },
        content
      );
    }
  }]);

  return Search;
}(_util2.default.BaseComponent);

var SimpleSearch = function (_M$BaseComponent$Mixi) {
  _inherits(SimpleSearch, _M$BaseComponent$Mixi);

  function SimpleSearch(props) {
    _classCallCheck(this, SimpleSearch);

    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(SimpleSearch).call(this, props));

    var model = _this2.props.model;

    var eventFactory = (0, _util3.buildEvents)(model);
    Object.assign(_this2.state, {
      loading: false,
      eventFactory: eventFactory
    });
    return _this2;
  }

  _createClass(SimpleSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchData();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props;
      var baseCls = _props2.className;
      var fields = _props2.model.fields;
      var loading = this.state.loading;

      return _react2.default.createElement(
        'div',
        { className: this.classNames() },
        _react2.default.createElement(
          'ul',
          { className: baseCls + '__list' },
          fields.map(function (f) {
            return _this3._renderField(f);
          })
        ),
        loading && _react2.default.createElement(
          'div',
          { className: baseCls + '__loading' },
          _react2.default.createElement(_spin2.default, null)
        )
      );
    }
  }, {
    key: '_renderField',
    value: function _renderField(field) {
      var _this4 = this;

      var condition = this.context.records._getCondition();
      var remoteData = this.state.remoteData;
      var code = field.code;
      var label = field.label;
      var model = field.model;
      var data = field.data;
      var type = field.type;

      var current = condition.get(code); //当前值
      var multiple = type == 'multiSelect';
      if (multiple) {
        current = (current || []).map(function (item) {
          return (0, _lodashCompat.isObject)(item) ? item.value : item;
        });
      } else {
        current = !!current && ((0, _lodashCompat.isObject)(current) ? current.value : current);
      }
      return _react2.default.createElement(
        'li',
        { key: field.code, className: 'simple-search__item' },
        _react2.default.createElement(
          'div',
          { className: 'simple-search__item__title' },
          _react2.default.createElement(
            'div',
            null,
            label,
            '：'
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: _util2.default.classNames("simple-search__item__data-list", { multiple: multiple }) },
          (data || remoteData && remoteData[field.code] || []).map(function (d, i) {
            var k = void 0,
                v = void 0,
                showContent = void 0;
            if (model) {
              //object传入
              var idField = model.idField;
              var showField = model.showField;
              var showTpl = model.showTpl;

              showContent = showTpl ? _util2.default.template(showTpl, d) : d[showField];
              k = d[idField];
              v = Object.assign({}, d, { value: k, label: showContent });
            } else {
              //纯字符串传入
              k = v = showContent = d;
            }
            return _react2.default.createElement(
              'li',
              { key: k,
                className: _util2.default.classNames('simple-search__item__data-list-item', {
                  active: !!current && (multiple ? current.includes(k) : current == k)
                }),
                onClick: _this4._onSelect.bind(_this4, i, v, field) },
              showContent
            );
          })
        )
      );
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(i, v, field) {
      var records = this.context.records;

      var condition = records._getCondition();
      var code = field.code;
      var type = field.type;

      var current = condition.get(code); //当前值
      var multiple = type == 'multiSelect';

      //如果当前值与选中值相同则清除
      var value = current == v || (0, _lodashCompat.isObject)(current) && current.value == v.value ? undefined : v;
      if (multiple) {
        //多选存在切换选中状态
        if (!current) {
          current = [];
        }
        var index = current.findIndex(function (item) {
          return (0, _lodashCompat.isObject)(v) ? v.value == item.value : v == item;
        });
        if (index == -1) {
          value = current.concat([v]);
        } else {
          value = current.slice();
          value.splice(index, 1);
        }
      }

      records._setCondition(_defineProperty({}, code, value));
    }
  }, {
    key: '_fetchData',
    value: function _fetchData() {
      return new Promise(function ($return, $error) {
        var $Try_1_Finally = function ($Try_1_Exit) {
          return function ($Try_1_Value) {
            this.setState({ loading: false });
            return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
          }.$asyncbind(this, $error);
        }.$asyncbind(this);

        var $Try_1_Catch = function ($exception_2) {
          return $Try_1_Finally($error)($exception_2);
        }.$asyncbind(this, $Try_1_Finally($error));

        function $Try_1_Post() {
          return $return();
        }

        var model = this.props.model;
        var eventFactory = this.state.eventFactory;

        var codeList = [],
            fetchEvents = [];
        // 可能定义事件并不是在events字段上，所以对全字段筛选
        model.fields.forEach(function (f) {
          var handler = eventFactory(f.code, 'bind');
          if (handler) {
            codeList.push(f.code);
            fetchEvents.push(eventFactory(f.code, 'bind')());
          }
        });
        this.setState({ loading: true });
        try {
          return Promise.resolve(Promise.all(fetchEvents)).then(function ($await_3) {
            var res = $await_3;
            var data = {};
            res.forEach(function (r, i) {
              data[codeList[i]] = r;
            });
            this.setState({ remoteData: data });
            return $Try_1_Finally($Try_1_Post).call(this);
          }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
        } catch ($exception_2) {
          $Try_1_Catch($exception_2)
        }
      }.$asyncbind(this));
    }
  }]);

  return SimpleSearch;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')));

Search.Simple = SimpleSearch;

var ComplexSearch = function (_M$BaseComponent$Mixi2) {
  _inherits(ComplexSearch, _M$BaseComponent$Mixi2);

  function ComplexSearch(props) {
    _classCallCheck(this, ComplexSearch);

    var _this5 = _possibleConstructorReturn(this, Object.getPrototypeOf(ComplexSearch).call(this, props));

    var model = props.model;
    var fields = model.fields;
    var advanced = model.advanced;
    var filter = model.filter;

    var modelExtra = _objectWithoutProperties(model, ['fields', 'advanced', 'filter']);

    var fieldsMap = {};
    var basicBillFields = [],
        advancedBillFields = [];
    for (var i = 0, length = fields.length; i < length; i++) {
      var f = fields[i];
      var code = f.code;
      var label = f.label;
      var show = f.show;
      var onlyShowIn = f.onlyShowIn;

      if (!onlyShowIn || onlyShowIn === 'basic') {
        basicBillFields.push({
          code: code, label: label,
          show: show !== false
        });
      }
      if (!onlyShowIn || onlyShowIn === 'advanced') {
        advancedBillFields.push({
          code: code, label: label
        });
      }
      fieldsMap[f.code] = f;
    }
    var eventFactory = (0, _util3.buildEvents)(model);
    Object.assign(_this5.state, {
      fieldsMap: fieldsMap, // 字段code映射关系，原始数据
      filter: filter, // 是否有自定义的条件展示
      basicBillFields: basicBillFields, // 只显示在表格上方的标准搜索区的字段
      advancedBillFields: advancedBillFields, // 只显示在高级搜索区的字段
      modelExtra: modelExtra, // 除fields等其他需要传给bill的字段
      showFilter: false, // 是否展示条件过滤器
      advanced: advanced || false, // 是否开启高级搜索
      eventFactory: eventFactory
    });
    // 初始化搜索区bill的字段改造后的映射
    _this5.searchBillFieldsMap = _this5._initSearchBillFieldsMap();
    _this5.searchBillModel = _this5._initSearchBillModel();
    _this5.searchData = {};
    return _this5;
  }

  _createClass(ComplexSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this6 = this;

      this.windowEventListener('click', function (e) {
        var showFilter = _this6.state.showFilter;
        var filter = _this6.refs.filter;

        if (showFilter && !(0, _reactDom.findDOMNode)(filter).contains(e.target)) {
          _this6._toggleFilter(false);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState, preContext) {
      var _this7 = this;

      //在更新之后重新给bill赋值
      var records = this.context.records;

      var condition = records._getCondition();
      var changedKeys = records._getChangedKeys();
      // 如果是过滤器发生改变，强制重新调整激活状态
      if (this.filterChanged || !condition.equals(this.lastCondition) && changedKeys.length > 0) {
        (function () {
          //condition驱动激活状态的变化，不外乎添加和删除两种
          var bill = _this7.refs.bill;

          changedKeys.map(function (key) {
            var model = bill.getFieldModel(key);
            var isExist = condition.has(key);
            // 搜索条件改变时，调整激活状态
            if (model) {
              _util2.default.mergeModel(model, {
                'conf.className': _util2.default.classNames('bill-item-content', { 'active-condition': isExist })
              });
              _util2.default.mergeModel(_this7.searchBillModel, _defineProperty({}, 'forms[0].fields.' + key, model));

              // 如果组件内存储的搜索数据为空，但是有传入新的搜索条件，表示传入了初始搜索条件
              if ((0, _lodashCompat.isEmpty)(_this7.searchData) && condition.size > 0) {
                (function () {
                  var fieldsMap = _this7.state.fieldsMap;

                  condition.forEach(function (value, key) {
                    // 只存储搜索条件，过滤掉表头筛选字段
                    if (fieldsMap[key]) {
                      _this7.searchData[key] = value;
                    }
                  });
                })();
              }

              //对于input、time，需要回传值，设置新值或删除旧值
              //input，需要展示当前值
              //time，选中时触发了change但是没有收起下拉框
              //自定义多选组件，需要回传值
              if (['text', 'password', 'number', 'time'].includes(model.type) || ['multiSelect', 'treeMultiSelect', 'checkbox'].includes(model._type_)) {
                //如果是新增的字段，保留
                if (isExist) {
                  bill.setFieldsData(_defineProperty({}, key, _this7.searchData[key]));
                } else {
                  bill.setFieldsData(_defineProperty({}, key, undefined));
                }
              }

              bill.setFieldModel(key, model);
            }

            //如果是删除的字段，从本地存储中删除，操作来源是直接删除条件字段或者全部删除
            !isExist && _this7.searchData && delete _this7.searchData[key];
          });
          _this7.filterChanged = false;
        })();
      }
      this.lastCondition = condition;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var baseCls = this.props.className;
      var _state = this.state;
      var filter = _state.filter;
      var basicBillFields = _state.basicBillFields;
      var showFilter = _state.showFilter;
      var advanced = _state.advanced;

      return _react2.default.createElement(
        'div',
        { ref: 'container', className: this.classNames() },
        _react2.default.createElement(_bill2.default, { ref: 'bill',
          initModel: this.searchBillModel,
          getPopupContainer: function getPopupContainer() {
            return _this8.refs.container;
          },
          onFieldChange: this._onFieldChange }),
        (advanced || filter) && _react2.default.createElement(
          'div',
          { className: baseCls + '__extend-search' },
          advanced && _react2.default.createElement(
            'div',
            { className: baseCls + '__advanced-search-entry',
              onClick: this._showAdvancedSearch },
            '高级搜索'
          ),
          filter && _react2.default.createElement(
            'div',
            { ref: 'filter', className: baseCls + '__custom-filter-wrapper' },
            _react2.default.createElement(_icon2.default, { className: baseCls + '__custom-filter-icon',
              type: 'settings', domProps: { onClick: this._toggleFilter.bind(this, !showFilter) } }),
            _react2.default.createElement(
              _popover2.default,
              { className: baseCls + '__popover-tip', placement: 'top' },
              '设置默认筛选条件'
            ),
            showFilter && _react2.default.createElement(
              _popover2.default,
              { className: baseCls + '__popover-filter' },
              _react2.default.createElement(_customFilter2.default, { className: baseCls + '__custom-filter',
                data: basicBillFields,
                onConfirm: this._onFilterChange,
                onCancel: this._toggleFilter.bind(this, false) })
            )
          )
        )
      );
    }

    /**
     * 生成搜索区bill的全字段映射关系
     * @private
     */

  }, {
    key: '_initSearchBillFieldsMap',
    value: function _initSearchBillFieldsMap() {
      var _this9 = this;

      var _state2 = this.state;
      var fieldsMap = _state2.fieldsMap;
      var basicBillFields = _state2.basicBillFields;
      var eventFactory = _state2.eventFactory;

      var searchBillFieldsMap = {};
      basicBillFields.forEach(function (f) {
        var nf = (0, _lodashCompat.cloneDeep)(fieldsMap[f.code]);
        // 初始化show属性
        nf.show = f.show;
        if (!nf.conf) {
          nf.conf = {};
        }

        if (nf.type == 'rangeDate') {
          console.warn('搜索条件当前不支持"rangeDate"类型，推荐使用"date"类型实现开始和结束时间');
        }

        // 单选|多选用下拉实现
        if (['radio', 'checkbox'].includes(nf.type)) {
          (function () {
            var data = nf.range || nf.conf.range || nf.conf.model || [];
            delete nf.conf.model; // 清除容易误解的属性
            nf._type_ = nf.type; //记录一下原type
            if (nf.type === 'radio') {
              nf.type = 'select';
              nf.onBind = function (bill, code, filter, callback) {
                var filteredData = data.filter(function (item) {
                  return item.label.indexOf(filter) !== -1;
                });
                callback(filteredData);
              };
            } else {
              nf._selectType_ = 'multiSelect';
              nf.type = 'custom';
              nf.Component = _MultiSelect2.default;
              nf.onFetchData = function (bill, code, filter, callback) {
                var filteredData = data.filter(function (item) {
                  return item.label.indexOf(filter) !== -1;
                });
                callback(filteredData);
              };
            }
            nf.model = {
              idField: 'value',
              showField: 'label'
            };
          })();
        }

        //在针对类型作变换之前，将multiSelect转换为自定义组件
        if (['multiSelect', 'treeMultiSelect'].includes(nf.type)) {
          nf._type_ = nf.type; //记录一下原type
          nf._selectType_ = nf.type;
          nf.type = 'custom';
          nf.Component = _MultiSelect2.default;
          nf.onFetchData = function (bill, code, filter, callback, errCallback) {
            var handler = eventFactory(code, 'bind', bill);
            handler(filter, callback, errCallback);
          };
          if (nf._selectType_ === 'treeMultiSelect') {
            nf.onFetchNodeData = function (bill, code, node, callback) {
              var handler = eventFactory(code, 'bindNode', bill);
              handler(node, callback);
            };
          }
        }

        //默认placeholder
        nf.conf.placeholder = nf.conf.placeholder || nf.label;
        //不显示label
        nf.showHeader = false;
        //清除所有的clearIcon
        nf.conf.clearIcon = false;

        //在字段上绑定onChange，阻止bill自动更新字段值并阻止了onControl和onFetch，同时调用传给bill的字段改变回调
        var changeFunc = nf.onChange;
        nf.onChange = function (value, bill, onFieldChange, doAction) {
          bill.setFieldsData(_defineProperty({}, nf.code, value), function () {
            onFieldChange(nf.code, value, bill);
            (0, _lodashCompat.isFunction)(changeFunc) && changeFunc.call(_this9, value, bill);
          }, 'notNowUpdate', 'noWarn');
        };

        //处理需要下拉高亮的字段
        if (['select', 'treeSelect', 'date', 'time'].includes(nf.type)) {
          (function () {
            //获取焦点时传值回组件，使得下拉选项高亮
            var focusFunc = nf.conf.onFocus;
            nf.conf.onFocus = function (code) {
              if (this.searchData && this.searchData[code]) {
                this.refs.bill.setFieldsData(_defineProperty({}, code, this.searchData[code]));
              }

              for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              (0, _lodashCompat.isFunction)(focusFunc) && focusFunc.call.apply(focusFunc, [null].concat(args));
            }.bind(_this9, nf.code);

            //失焦时移除值
            var blurFunc = nf.conf.onBlur;
            nf.conf.onBlur = function (code) {
              this.refs.bill.setFieldsData(_defineProperty({}, code, undefined));

              for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
              }

              (0, _lodashCompat.isFunction)(blurFunc) && blurFunc.call.apply(blurFunc, [null].concat(args));
            }.bind(_this9, nf.code);
          })();
        }

        //对字段的特殊处理 FIXME 整理一下吧

        (function () {
          switch (nf.type) {
            case 'text':
            case 'password':
            case 'number':
              nf.addonAfter = createAddonAfter(nf.addonAfter, _this9._updateCondition.bind(_this9, false));
              nf.conf.trigger = 'onChange';
              if (!nf.conf.domProps) {
                nf.conf.domProps = {};
              }
              //回车时确认搜索
              var keyDownFunc = nf.conf.domProps.onKeyDown;
              Object.assign(nf.conf.domProps, {
                onKeyDown: function onKeyDown() {
                  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3];
                  }

                  var e = args[0];
                  if (e.keyCode == _KeyCode2.default.ENTER) {
                    _this9._updateCondition();
                  }
                  (0, _lodashCompat.isFunction)(keyDownFunc) && keyDownFunc.call.apply(keyDownFunc, [null].concat(args));
                }
              });
              var blurFunc = nf.conf.onBlur;
              nf.conf.onBlur = function () {
                for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  args[_key4] = arguments[_key4];
                }

                // 输入框失去焦点时需要通知外部条件更新但不触发搜索
                _this9._updateCondition(true);
                (0, _lodashCompat.isFunction)(blurFunc) && blurFunc.call.apply(blurFunc, [null].concat(args));
              };
              break;
            case 'select':
            case 'treeSelect':
              if (!nf.model) {
                nf.model = {};
              }
              Object.assign(nf.model, {
                //默认展示6条的高度
                height: nf.model.height || 216
              });
              break;
            case 'date':
              nf.conf.trigger = 'onConfirm';
              break;
            case 'rangeDate':
              //时间段的placeholder必须是个数组
              nf.conf.placeholder = nf.conf.placeholder == nf.label ? [nf.label, nf.label] : nf.conf.placeholder;
              break;
          }
        })();

        searchBillFieldsMap[nf.code] = nf;
      });
      return searchBillFieldsMap;
    }

    /**
     * 生成搜索区的bill model
     * @returns {{forms: [*]}}
     * @private
     */

  }, {
    key: '_initSearchBillModel',
    value: function _initSearchBillModel() {
      var _this10 = this;

      var _state3 = this.state;
      var basicBillFields = _state3.basicBillFields;
      var modelExtra = _state3.modelExtra;

      var fields = [];
      basicBillFields.forEach(function (item) {
        if (item.show) {
          fields.push(_this10.searchBillFieldsMap[item.code]);
        }
      });
      return _extends({ forms: [{ fields: fields }] }, modelExtra);
    }

    /**
     * 生成高级搜索区的bill model
     * @private
     */

  }, {
    key: '_formAdvancedSearchBillModel',
    value: function _formAdvancedSearchBillModel() {
      var _state4 = this.state;
      var fieldsMap = _state4.fieldsMap;
      var advancedBillFields = _state4.advancedBillFields;
      var modelExtra = _state4.modelExtra;

      var fields = advancedBillFields.map(function (item) {
        // 传入bill之前把所有字段的show属性删除
        delete fieldsMap[item.code].show;
        return fieldsMap[item.code];
      });
      return _extends({ forms: [{ fields: fields }] }, modelExtra, { column: 1 });
    }

    /**
     * 展示的搜索条件改变时只切换在bill中的显示状态
     * @param basicBillFields
     * @private
     */

  }, {
    key: '_onFilterChange',
    value: function _onFilterChange(basicBillFields) {
      this._toggleFilter(false);
      this.setState({ basicBillFields: basicBillFields }, this._setSearchBillFields);
    }

    /**
     * 重新设定字段的显示状态和顺序
     * @private
     */

  }, {
    key: '_setSearchBillFields',
    value: function _setSearchBillFields() {
      var _this11 = this;

      var bill = this.refs.bill;
      var basicBillFields = this.state.basicBillFields;

      var fields = [];
      basicBillFields.forEach(function (item) {
        // 更新显示状态
        _this11.searchBillFieldsMap[item.code].show = item.show;
        if (item.show) {
          fields.push(_this11.searchBillFieldsMap[item.code]);
        }
      });
      this.searchBillModel.forms[0].fields = fields;

      bill.setModel(this.searchBillModel, function () {
        // 过滤器变化设定字段
        _this11.filterChanged = true;
        _this11.forceUpdate();
        var records = _this11.context.records;
        var basicBillFields = _this11.state.basicBillFields;

        records._onSearchFieldsFilter(basicBillFields.filter(function (f) {
          return f.show;
        }).map(function (f) {
          return f.code;
        }), basicBillFields);
      });
    }

    /**
     * 简易搜索字段变化时只存储条件到本地
     * @param code
     * @param value
     * @param bill
     * @private
     */

  }, {
    key: '_onFieldChange',
    value: function _onFieldChange(code, value, bill) {
      var model = bill.getFieldModel(code);
      switch (model.type) {
        case 'select':
        case 'treeSelect':
          //如果value是对象且value.value是假值
          if ((0, _lodashCompat.isObject)(value) && !value.value) {
            value = undefined;
          }
          break;
        case 'rangeDate':
          //如果开始和结束都不存在且不是至今
          if (!value[0] && !value[1] && !value[2]) {
            value = [];
          }
          break;
      }
      Object.assign(this.searchData, _defineProperty({}, code, value));
      //这几种类型的字段非立即搜索
      if (!['text', 'password', 'number'].includes(model.type)) {
        this._updateCondition();
      } else {
        // 输入框的值始终让bill记忆
        bill.setFieldsData(_defineProperty({}, code, value));
      }
    }

    /**
     * 通知外部更新搜索条件
     * @private
     */

  }, {
    key: '_updateCondition',
    value: function _updateCondition(isTemporary) {
      var records = this.context.records;

      records._setCondition(this.searchData, isTemporary);
    }
  }, {
    key: '_toggleFilter',
    value: function _toggleFilter(show) {
      this.setState({
        showFilter: show
      });
    }
  }, {
    key: '_showAdvancedSearch',
    value: function _showAdvancedSearch() {
      var _this12 = this;

      var baseCls = this.props.className;
      var fieldsMap = this.state.fieldsMap;

      var model = this._formAdvancedSearchBillModel();
      var billData = {};
      for (var field in this.searchData) {
        var _model = fieldsMap[field];
        if (_model) {
          var searchValue = this.searchData[field];
          if (_model.type === 'radio') {
            billData[field] = searchValue && searchValue.value;
          } else if (_model.type === 'checkbox') {
            billData[field] = (((0, _lodashCompat.isArray)(searchValue) ? searchValue : [searchValue]) || []).map(function (item) {
              return item.value;
            });
          } else {
            billData[field] = searchValue;
          }
        }
      }
      _slidingPanel2.default.show(function (props) {
        return _react2.default.createElement(_AdvancedSearch2.default, { className: baseCls + '__advanced-search',
          model: model,
          searchData: _this12.searchData,
          billData: billData,
          onClose: _this12._hideAdvancedSearch,
          onConfirm: _this12._confirmAdvancedSearch });
      }, { className: '' + (!!model.code ? 'sliding-panel__' + model.code : '') });
    }
  }, {
    key: '_hideAdvancedSearch',
    value: function _hideAdvancedSearch() {
      _slidingPanel2.default.hide();
    }
  }, {
    key: '_confirmAdvancedSearch',
    value: function _confirmAdvancedSearch(searchData, billData) {
      this._hideAdvancedSearch();
      this.searchData = searchData;
      this._updateCondition();
    }
  }, {
    key: '_doControl',
    value: function _doControl(control) {
      var _this13 = this;

      var show = control.show;
      var hide = control.hide;
      var editable = control.editable;
      var disabled = control.disabled;
      var bill = this.refs.bill;

      (show || []).forEach(function (key) {
        var model = bill.getFieldModel(key);
        _util2.default.mergeModel(model, {
          show: true
        });
        _util2.default.mergeModel(_this13.searchBillModel, _defineProperty({}, 'forms[0].fields.' + key, model));
        bill.setFieldModel(key, model);
      });
      (hide || []).forEach(function (key) {
        var model = bill.getFieldModel(key);
        _util2.default.mergeModel(model, {
          show: false
        });
        _util2.default.mergeModel(_this13.searchBillModel, _defineProperty({}, 'forms[0].fields.' + key, model));
        bill.setFieldModel(key, model);
      });
      (editable || []).forEach(function (key) {
        var model = bill.getFieldModel(key);
        _util2.default.mergeModel(model, {
          disabled: false
        });
        _util2.default.mergeModel(_this13.searchBillModel, _defineProperty({}, 'forms[0].fields.' + key, model));
        bill.setFieldModel(key, model);
      });
      (disabled || []).forEach(function (key) {
        var model = bill.getFieldModel(key);
        _util2.default.mergeModel(model, {
          disabled: true
        });
        _util2.default.mergeModel(_this13.searchBillModel, _defineProperty({}, 'forms[0].fields.' + key, model));
        bill.setFieldModel(key, model);
      });
    }
  }]);

  return ComplexSearch;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')));

Search.Complex = ComplexSearch;

/**
 * 对于输入框类型，需要在后面加搜索放大镜
 * 如果传入的ReactElement是在组件内调用生成的，则该Element会获得当前的ReactOwner
 * 造成Bill首次渲染延迟300多ms，更新渲染延迟600多ms
 * 因此在外层先生成无owner的组件，用cloneElement实现组件的自定义
 */

var StandardAddonAfter = function (_M$BaseComponent2) {
  _inherits(StandardAddonAfter, _M$BaseComponent2);

  function StandardAddonAfter() {
    _classCallCheck(this, StandardAddonAfter);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(StandardAddonAfter).apply(this, arguments));
  }

  _createClass(StandardAddonAfter, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var children = _props3.children;
      var onSearch = _props3.onSearch;

      return _react2.default.createElement(
        'div',
        { className: 'bill-item-addon-after__inner' },
        _react2.default.createElement(_icon2.default, { className: 'bill-item-addon-after__search-icon',
          type: 'search', domProps: { onClick: onSearch } }),
        children
      );
    }
  }]);

  return StandardAddonAfter;
}(_util2.default.BaseComponent);

var standardAddonAfter = _react2.default.createElement(StandardAddonAfter, null);exports.default = Search;